$(->
  $(document).ajaxComplete ->
    $('body').removeClass('loading')

  $(document).on 'show.bs.modal', '.modal', (e)->
    $('body').removeClass('loading')

  $(document).on 'click', 'a', ->
    if $(this).data('remote')? || $(this).hasClass('remote')
      $('body').addClass('loading')
  $(document).on 'submit', 'form', ->
    if $(this).data('remote')?
      $('body').addClass('loading')
)
